import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const ARTCAST_USER_ARTWORKS_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/user-artworks',
        iconClass: 'fas fa-pencil-ruler',
        name: 'My Artworks',
        layout: eLayoutType.application,
        requiredPolicy: 'Artcast.AppUser_Artworks',
        order: 3
      },
    ]);
  };
}
